/*
  The errorMessages object holds messages in both Dutch and English.
  These messages serve distinct purposes.
  If a field validation fails, a user-friendly Dutch message appears below the input form.
  In case of an error, a more technical English message is logged.
*/

const tooLongMsg = (maxLength, polite = false) =>
  polite
    ? `Probeer maximaal ${maxLength} tekens te gebruiken`
    : `Te lang, maximaal ${maxLength} tekens`;

export const errorMessages = {
  nl: {
    firstname: {
      empty: 'Vul uw voornaam in',
      invalid: 'Vul alleen letters en spaties in',
      length: tooLongMsg(256),
    },
    insertion: {
      invalid: 'Vul alleen letters en spaties in',
      length: tooLongMsg(256),
    },
    lastname: {
      empty: 'Vul uw achternaam in',
      invalid: 'Vul alleen letters en spaties',
      length: tooLongMsg(128),
    },
    email: {
      empty: 'Vul uw email in',
      invalid: 'Vul een geldig email adres in',
    },
    countryCode: {
      empty: 'Vul een landcode in (voorbeeld: +31)',
      invalid: 'Vul een geldige landcode in',
    },
    mobilePhone: {
      empty: 'Vul uw telefoonnummer in',
      invalid: 'Vul een geldig telefoonnummer in',
    },
    streetname: {
      empty: 'Vul uw straatnaam in',
      invalid: 'Vul alleen letters en spaties in',
      length: tooLongMsg(128),
    },
    housenumber: {
      empty: 'Vul uw huisnummer in',
      invalid: 'Vul een geldig huisnummer in',
    },
    zipcode: {
      empty: 'Vul een postcode in',
      invalid: 'Vul een geldige postcode in',
    },
    city: {
      empty: 'Vul een woonplaats in',
      invalid: 'Vul een geldige woonplaats in',
      length: tooLongMsg(100),
    },
    title: {
      empty: 'Omschrijf uw klus in een paar woorden',
      invalid: 'Gebruik alleen cijfers, letters en spaties',
      length: tooLongMsg(30, true),
    },
    description: {
      empty: 'Vul een uigebreidere omschrijving van uw klus in',
      invalid: 'Gebruik alleen letters, cijfers en spaties',
      length: tooLongMsg(1000, true),
    },
    images: {
      invalid: 'U mag alleen afbeeldingen uploaden',
      length: 'U kunt maximaal 5 afbeeldingen uploaden'
    }
  },
  en: {
    firstname: {
      empty: 'firstname is empty',
      invalid: 'firstname is invalid',
      length: 'firstname exceeds max length of 256',
    },
    insertion: {
      invalid: 'insertion is invalid',
      length: 'insertion exceeds max length of 256',
    },
    lastname: {
      empty: 'lastname is empty',
      invalid: 'lastname is invalid',
      length: 'lastname exceeds max length of 128',
    },
    email: {
      empty: 'email is empty',
      invalid: 'email is invalid',
    },
    countryCode: {
      empty: 'countryCode is empty',
      invalid: 'countryCode is invalid',
    },
    mobilePhone: {
      empty: 'mobilePhone is empty',
      invalid: 'mobilePhone is invalid',
    },
    streetname: {
      empty: 'streetname is empty',
      invalid: 'streetname is invalid',
      length: 'streetname exceeds max length of 128',
    },
    housenumber: {
      empty: 'housenumber is empty',
      invalid: 'housenumber is invalid',
    },
    zipcode: {
      empty: 'zipcode is empty',
      invalid: 'zipcode is invalid',
    },
    city: {
      empty: 'city is empty',
      invalid: 'city is invalid',
      length: 'city exceeds max length of 100',
    },
    title: {
      empty: 'title is empty',
      invalid: 'title is invalid',
      length: 'title exceeds max length of 30',
    },
    description: {
      empty: 'description is empty',
      invalid: 'description is invalid',
      length: 'description exceeds max length of 1000',
    },
    images: {
      invalid: 'uploaded images are of invalid file type',
      length: 'uploaded images exceed the maximum length of 5'
    }
  },
};

export const getErrorMessage = (key, language = 'nl') => {
  if (key) {
    const messages = errorMessages[language] || errorMessages.nl;
    const keys = key.split('.');
    let message = messages;

    keys.forEach((k) => {
      message = message[k];
    });

    return message;
  }

  return '';
};
